import * as React from "react"

const InfoIconSVG = (props) => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g id="Info icon">
			<g id="Group">
				<path
					id="Vector"
					d="M6 10.5C8.48528 10.5 10.5 8.48528 10.5 6C10.5 3.51472 8.48528 1.5 6 1.5C3.51472 1.5 1.5 3.51472 1.5 6C1.5 8.48528 3.51472 10.5 6 10.5Z"
					stroke="#475163"
					stroke-linecap="round"
					stroke-linejoin="round"
				/>
				<path id="Vector_2" d="M6 4H6.00545V4.00545H6V4Z" stroke="#475163" stroke-linejoin="round" />
				<path id="Vector_3" d="M6 6V8" stroke="#475163" stroke-linecap="round" stroke-linejoin="round" />
			</g>
		</g>
	</svg>
)

export default InfoIconSVG
